import { useEffect } from 'react';
import styles from './CommentsModal.module.css';

const formatDate = (s) => {
  if (!s) return '';
  const d = new Date(s);
  if (isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

const formatNumber = (num) => {
  const n = num || 0;
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return n;
};

const CommentsModal = ({ comments, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const list = Array.isArray(comments) ? comments : [];

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.title}>댓글</div>
          <button className={styles.close} onClick={onClose}>×</button>
        </div>
        <div className={styles.list}>
          {list.length === 0 && <div className={styles.state}>댓글이 없습니다.</div>}
          {list.map((c, i) => (
            <div className={styles.item} key={c.comment_id || i}>
              <div className={styles.itemHead}>
                {c.commenter_url
                  ? <a className={styles.author} href={c.commenter_url} target="_blank" rel="noopener noreferrer">{c.commenter_name || '익명'}</a>
                  : <span className={styles.author}>{c.commenter_name || '익명'}</span>}
                <span className={styles.date}>{formatDate(c.comment_date)}</span>
              </div>
              <div className={styles.text}>{c.comment_text}</div>
              <div className={styles.meta}>
                <span>♥ {formatNumber(c.num_likes)}</span>
                <span>답글 {formatNumber(c.num_replies)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommentsModal;
